/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'people.menu.renotify.flag.description': 'Lähetämme kaikille muistutuksen. Tämä voi viedä minuutin.',
  'people.menu.renotify.flag.description.confluence': 'Muistuta tiimikavereita',
  'people.menu.renotify.flag.title': 'Lähetetään muistutuksia',
  'people.menu.renotify.flag.title.confluence': 'Lähetetään kutsu uudelleen sähköpostitse',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} henkilö ei ole hyväksynyt {product}-kutsuaan. Katso, kuka puuttuu, ja lähetä hänelle muistutus.} other {{userCount,number} henkilöä ei ole hyväksynyt {product}-kutsuaan. Katso, ketkä puuttuvat, ja lähetä heille muistutus.}}',
  'people.menu.renotify.menu.description.confluence':
    'Jotkut eivät ole hyväksyneet Confluence-kutsuaan. Katso, ketkä puuttuvat, ja lähetä heille muistutus.',
  'people.menu.renotify.menu.dismiss': 'Hylkää',
  'people.menu.renotify.menu.dismiss.confluence': 'Ei nyt',
  'people.menu.renotify.menu.remind': 'Muistuta tiimin jäseniä',
  'people.menu.renotify.menu.remind.confluence': 'Muistuta tiimikavereita',
  'people.menu.renotify.menu.title': 'Ovatko kaikki mukana?',
  'people.menu.renotify.modal.copied': 'Linkki kopioitu',
  'people.menu.renotify.modal.copy': 'Kopioi kutsulinkki',
  'people.menu.renotify.modal.description':
    'Voimme lähettää muistutuksen puuttuville jäsenille, tai voit jakaa kutsulinkin itse.',
  'people.menu.renotify.modal.description.confluence':
    'Lähetä kutsusähköposti uudelleen tai kopioi ja jaa kutsulinkki.',
  'people.menu.renotify.modal.dismiss': 'Peruuta',
  'people.menu.renotify.modal.resend': 'Lähetä muistutus',
  'people.menu.renotify.modal.resend.confluence': 'Lähetä kutsu uudelleen',
  'people.menu.renotify.modal.title': 'Muistuta poissaolevia jäseniä',
  'people.menu.renotify.modal.title.confluence': 'Muistuta poissaolevia tiimin jäseniä',
  'ptc.pm.collaborators.title': 'Työkumppanisi',
  'ptc.pm.error-heading': 'Jokin meni pieleen',
  'ptc.pm.error-image-alt-text': 'Rikkinäinen robotti - monta ahkeraa ihmistä korjaa vikaa.',
  'ptc.pm.error-text': 'Seuraamme näitä virheitä, mutta ota epäröimättä yhteyttä, jos sivun päivitys ei auta',
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} jäsen} other {{memberCount,number} jäsentä}}',
  'ptc.pm.people': 'Ihmiset',
  'ptc.pm.teams': 'Tiimit',
  'ptc.pm.view-your-profile': 'Näytä profiilisi',
  'ptc.pm.your-teams.title': 'Tiimisi',
};
